var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({attrs:{"color":_vm.color,"role":"presentation"},domProps:{"textContent":_vm._s(_vm.icon)}},'v-icon',attrs,false),on))]}}])},[_c('span',{domProps:{"textContent":_vm._s(_vm.tooltip)}})])}
var staticRenderFns = []

export { render, staticRenderFns }